import { useEffect, useRef, useState } from 'react';
import DeviceModelEdit from './DeviceModelEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../../utilsTsx/components/system/columnshead';
import { Space, Tooltip } from 'antd';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';

const WebComponent = (props: any) => {
    const ref = useRef<any>(undefined);
    const apiId = 'deviceModel';

    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>()
    const [deviceTypeData, setDeviceTypeData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService
            setFetchData(() => ref.current.fetchData);
        }
        fetchApi.GET(urlService, {
            query: {
                apiId: 'deviceType',
                apiExtend: 'showList'
            }
        }).then(res => {
            if (res.success) {
                setDeviceTypeData([{ id: 'ALLITEM', typeName: '所有' }, ...res.data]);
            }
        })
    }, []);

    //表头
    const columnsHead = [
        {
            title: '型号名',
            dataIndex: 'modelName'
        },
        {
            title: '编码',
            dataIndex: 'code'
        },
        {
            title: '设备类',
            dataIndex: ['deviceType', 'typeName'],
            render: (val: string) => val || '-'
        },
        {
            title: '蓝牙名前缀',
            dataIndex: 'bleNamePrefix'
        },
        {
            title: '主控芯片',
            dataIndex: 'chip'
        },
        {
            title: '芯片家族',
            dataIndex: 'family'
        },
        {
            title: '制造商',
            dataIndex: 'manufacturer'
        },
        {
            title: '描述',
            dataIndex: 'description',
            render: (val: string) =>
                <Tooltip placement="topLeft" title={val}>{
                    val?.length >= 8 ? val?.substring(0, 8) + '......' : val
                }</Tooltip>
        },
        {
            title: '排序',
            dataIndex: 'sort'
        },
    ];

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '设备型号',
        apiId,
        columns,
        serviceId: 'mf',
        editOptions: {
            Editor: DeviceModelEdit
        }
    };

    return (
        <> <Space>
            <CustomSelect
                apiId={apiId}
                sendKeyId='deviceTypeId'
                getListData={deviceTypeData}
                sendPageData={sendPageData}
                setSendPageData={setSendPageData}
                fetchData={fetchData}
                itemName="typeName"
            />
        </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;